import { RootState } from '@client/redux/types';
import {
    setClientWidth,
    setClientHeight,
    setClientOffsetTop,
} from '@client/redux/modules/clientDevice/actions';
import { Store } from 'redux';

export const setClientDimensions = (reduxStore: Store<RootState>) => {
    // TODO window.innerWidth and document.documentElement.clientWidth return different values
    // E.g. on iOS Safari Zoom-in. We need either to store the values separately or agree on smth
    const width =
        window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    reduxStore.dispatch(setClientWidth(width));

    const height = document.documentElement.clientHeight;
    reduxStore.dispatch(setClientHeight(height));
};

export const setClientOffset = (store: Store<RootState>) => {
    const offsetTop = window.pageYOffset || document.documentElement.scrollTop;
    store.dispatch(setClientOffsetTop(offsetTop));
};
